import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledSnackbar = styled(Stack)(({ theme, variant }) => ({
  width: "100%",
  backgroundColor: theme.palette[variant].main,
  borderRadius: 16,
  padding: 15,
}));

export default StyledSnackbar;
